import truncate from 'components/shared/mixins/truncate'
import { mapGetters } from 'vuex'
import routeHelper from 'components/shared/mixins/routeHelper'

export default {
    props: {
        learningPath: Object,
        index: {
            type: Number,
            default: null
        },
        editable: Boolean,
        isWatchListItem: {
            type: Boolean,
            default: false
        },
        isBeingEdited: {
            type: Boolean,
            default: false
        },
        isUnCompletedView: {
            type: Boolean,
            default: false
        },
        isCompletedView: {
            type: Boolean,
            default: false
        }
    },
    mixins: [ truncate, routeHelper ],
    data () {
        return {
            descLength: 250
        }
    },
    computed: {
        ...mapGetters({
            isCourseCompleted: 'CompletedCourses/isCourseCompleted',
            completedCourses: 'CompletedCourses/certificates',
            isLoggedIn: 'isLoggedIn',
            mapCollectionToRibbon: 'CoursesCollections/mapCollectionToRibbon',
            mapCollectionToTimeBasedRibbon: 'CoursesCollections/mapCollectionToTimeBasedRibbon',
            subscribedLearningPaths: 'LearningPaths/getSubscribedLearningPaths'
        }),
        tooltipText () {
            return this.$t('BannerCollectionInfo.please_note_bla_bla')
        },
        title () {
            return this.learningPath.title || 'undefined'
        },
        courses () {
            if (this.learningPath.courses) {
                return this.learningPath.courses
            }

            return this.learningPath.items.filter(item => item.type === 'course')
        },
        showAddToFavourite () {
            return this.isLoggedIn && !this.isWatchListItem
        },
        isFree () {
            return this.learningPath.flags[0] === 'free'
        },
        isPromotional () {
            return this.learningPath.flags[0] === 'promotional'
        },
        userHasNoAccess () {
            return this.learningPath.demo && this.isLoggedIn
        },
        isExpired () {
            if (this.mapCollectionToRibbon(this.learningPath, true)) {
                return this.mapCollectionToRibbon(this.learningPath, true).name === this.$t('Ribbon.unavailable')
            }
            return false
        },
        isCompletedLearningPathExpired () {
            return this.learningPath.learningPath.isExpired
        },
        isWatchListItemInEditMode () {
            return this.isBeingEdited && this.isWatchListItem
        },
        image () {
            return this.learningPath.image?.url
        },
        isImage () {
            return this.image
        },
        isLearningPathCompleted () {
            return this.learningPath.hasUserCertificate || this.learningPath.canUserCreateCertificate || !!(this.learningPath.certificate)
        },
        isLearningPathSubscribed () {
            if (!this.subscribedLearningPaths) {
                return false
            }

            if (this.learningPath.certificate) {
                return true
            }
            return this.subscribedLearningPaths.some(subscribed => this.learningPath.id === subscribed.id)
        },
        progress () {
            if (this.learningPath.certificate) {
                return 100
            }

            return this.learningPath.percentageCompleted
        },
        truncateDescription () {
            if (this.learningPath.description.length < this.descLength) {
                return this.learningPath.description
            } else {
                return this.learningPath.description.substring(0, this.descLength) + '...'
            }
        }
    }
}
